import styled from 'styled-components';
import { FontSize, FontWeight } from 'commons';

export const HeadingStyle = styled.h2<{
  $size: FontSize;
  $weight: FontWeight;
}>`
  font-size: ${({ $size }) => $size};
  font-weight: ${({ $weight }) => $weight};
  color: inherit;
`;
